import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { UiModalComponent } from '@components';
import { ILicense } from '@models';

@Component({
  selector: 'ui-expired.modal',
  templateUrl: './expired.modal.html',
  styleUrls: ['./expired.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ExpiredModalComponent
  extends UiModalComponent<ILicense> {

}
